import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_CHALLENGES_MUTATION } from '../graphql/mutations'
import { transformToSaveChallengesArgs } from '../graphql/transformers'
import { SAVE_CHALLENGES } from '../redux/action-types'

const useSaveChallengesMutation = refetchLastEvent => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(store => store.challenges.challenges)

  const mutate = useCallback(
    async data => {
      await apolloService.mutate(
        SAVE_CHALLENGES_MUTATION,
        { data: transformToSaveChallengesArgs(data) },
        dispatch,
        SAVE_CHALLENGES,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveChallengesMutation
